import React from 'react';
import { styled,  Box, Grid, Container} from '@mui/material';
// import Markdown from 'markdown-to-jsx';
import { MuiMarkdown as Markdown, getOverrides} from 'mui-markdown';
import ComponentContainer from './atoms/ComponentContainer';
import ComponentHeading from './atoms/ComponentHeading';

import { Button } from './atoms/Button';

import type { Hero as HeroProps } from '../types/app';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const StyledImageContainer = styled('div')`
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    z-index:-1;
`;

const StyledImage = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const TextOverlay = styled(Box)(({ theme}) => ({
    borderRadius    : theme.spacing(1),
    backgroundColor : 'rgba(255, 255, 255, 0.5)', // Semi-transparent background
    padding         : theme.spacing(2),
    paddingLeft     : theme.spacing(4),
    boxSizing       : 'border-box',
    textAlign       : 'left',
}));

  

export const Hero = (props: HeroProps) => {

    const image         = props.image ? getImage(props.image) : null;
    const fullWidth     = Boolean(props.imageFullWidth);

    return (
        <ComponentContainer fullWidth={true} contentful_id={props.contentful_id} sx={{position:'relative'}}>

            {
                image && fullWidth && 
                <StyledImageContainer>
                    <StyledImage 
                        image               = {image} 
                        alt                 = {props.image.title} 
                        data-sb-field-path  = "image"
                    />
                </StyledImageContainer>
            }
            
            <Container maxWidth="lg">

                <Grid container spacing={2} direction={props.theme !== 'imgLeft' ? 'row' : 'row-reverse'} sx={{minHeight:300,my:10}}>

                    <Grid item xs={12} lg={image ? 6 : 12} xl={image ? 8 : 12} sx={{'& > * + *' : {mt:4}}}>
                        <Box display="flex" flexDirection={"column"} sx={{height:'100%'}}>
                            <TextOverlay sx={{my:4}}>
                                <ComponentHeading>
                                    {props.heading}
                                </ComponentHeading>
                                {
                                    props.body && (
                                        <>
                                            <Box flexGrow={1}/>
                                            <Box>
                                                <Markdown 
                                                    overrides={{
                                                        ...getOverrides({}), // This will keep the other default overrides.
                                                        p : {
                                                            component : 'p',
                                                            props : {
                                                                style: { 
                                                                    textAlign: 'justify' 
                                                                },
                                                            },
                                                        },
                                                    }}
                                                    //options = {{ forceBlock: true }} 
                                                    data-sb-field-path="body"
                                                >
                                                    {props.body.body}
                                                </Markdown>
                                            </Box>
                                            <Box flexGrow={1}/>
                                        </>
                                    )
                                }
                                {
                                    props.button && props?.button?.url !== '#' &&
                                    <Box textAlign={props.theme !== 'imgRight' ? 'right' : 'left'} sx={{my:4}}>
                                        <Button color="success" {...props.button} data-sb-field-path="button" />
                                    </Box>
                                }
                            </TextOverlay>
                        </Box>
                    </Grid>

                    {
                        image &&
                        <Grid item xs={12} lg={6} xl={4} sx={{px:2}}>
                            {
                                image && !fullWidth &&
                                <Box display={"flex"} flexDirection={"column"} sx={{height:'100%'}}>
                                    <Box flexGrow={1}/>
                                    <Box sx={{width:'100%', maxWidth:500, mx:'auto'}}>
                                        <GatsbyImage 
                                            image               = {image} 
                                            alt                 = {props.image.title} 
                                            data-sb-field-path  = "image"
                                        />
                                    </Box>
                                    <Box flexGrow={1}/>
                                </Box>
                            }
                        </Grid>
                    }

                </Grid>
            </Container>
        </ComponentContainer>

        /*
        <div className="px-12 py-24 bg-gray-100" data-sb-object-id={props.contentful_id}>
            <div className={`flex mx-auto max-w-6xl gap-12 ${themeClassMap[props.theme] ?? themeClassMap['imgRight']}`}>
                <div className="max-w-xl py-20 mx-auto lg:shrink-0">
                    <h1 className="mb-6 text-5xl leading-tight" data-sb-field-path="heading">
                        {props.heading}
                    </h1>
                    {
                        props.body && (
                            <Markdown options={{ forceBlock: true }} className="mb-6 text-lg" data-sb-field-path="body">
                                {props.body.body}
                            </Markdown>
                        )
                    }
                    {
                        props.button && props?.button?.url !== '#' &&
                        <Button {...props.button} data-sb-field-path="button" />
                    }
                </div>
                <div className="relative hidden w-full overflow-hidden rounded-md lg:block">
                    {
                        image && 
                        <GatsbyImage image={image} alt={props.image.title} data-sb-field-path="image"/>
                    }
                </div>
            </div>
        </div>
        */
    );
};

export default Hero;
